import {useMediaQuery} from "@mui/material";
import {theme} from "../../Tema";

export const useResponsive = () => {
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))
    const sTab = useMediaQuery(theme.breakpoints.only('sm'))
    const sLarge = useMediaQuery(theme.breakpoints.only('xl'))

    const esSafari = () =>{
        if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
            return true
        } else {
           return false
        }
    }

    function esIPhone() {
        const userAgent = navigator.userAgent;
        if (/iPhone|iPad|iPod/.test(userAgent)) {
            return true; // Es un dispositivo iOS
        }
        return false; // No es un dispositivo iOS
    }



    return {
        masSM,
        sCell,
        sTab,
        sLarge,
        esSafari,
        esIPhone
    }
}